var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArchAwsDataExchange32(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon-Architecture/32/Arch_AWS-Data-Exchange_32") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "0%",
    y1: "100%",
    x2: "100%",
    y2: "0%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4D27A8",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A166FF",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture/32/Arch_AWS-Data-Exchange_32",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-Architecture-BG/32/Analytics",
    fill: "url(#linearGradient-1)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 0,
    y: 0,
    width: 40,
    height: 40
  })), /*#__PURE__*/React.createElement("path", {
    d: "M16.298,27.242 L14.263,25.207 L16.298,23.172 L15.591,22.465 L13.202,24.853 C13.007,25.049 13.007,25.365 13.202,25.56 L15.591,27.949 L16.298,27.242 Z M26.354,14.56 C26.549,14.365 26.549,14.049 26.354,13.853 L23.965,11.465 L23.258,12.172 L25.293,14.207 L23.258,16.242 L23.965,16.949 L26.354,14.56 Z M25,26.02 L31,26.02 L31,25.02 L25,25.02 L25,26.02 Z M19,30.02 L34,30.02 L34,29.02 L19,29.02 L19,30.02 Z M9,15.02 L15,15.02 L15,14.02 L9,14.02 L9,15.02 Z M6,11.02 L21,11.02 L21,10.02 L6,10.02 L6,11.02 Z M24.265,7 C22.976,7 21.703,7.329 20.583,7.952 L21.069,8.826 C22.04,8.286 23.146,8 24.265,8 C27.896,8 30.85,10.954 30.85,14.585 C30.85,18.216 27.896,21.17 24.265,21.17 C23.826,21.17 23.394,21.11 22.967,21.021 C22.939,21.097 22.636,21.932 22.622,21.972 C23.161,22.093 23.709,22.17 24.265,22.17 C28.447,22.17 31.85,18.767 31.85,14.585 C31.85,10.403 28.447,7 24.265,7 L24.265,7 Z M17.905,16.304 C17.756,15.745 17.68,15.167 17.68,14.585 C17.68,13.711 17.848,12.864 18.179,12.067 L17.255,11.683 C16.873,12.602 16.68,13.579 16.68,14.585 C16.68,15.255 16.768,15.92 16.941,16.563 L17.905,16.304 Z M21.5,32.02 L9.5,32.02 C9.224,32.02 9,31.797 9,31.52 L9,19.52 C9,19.244 9.224,19.02 9.5,19.02 L21.5,19.02 C21.777,19.02 22,19.244 22,19.52 L22,28.02 L21,28.02 L21,20.02 L10,20.02 L10,31.02 L22,31.02 L22,31.52 C22,31.797 21.777,32.02 21.5,32.02 L21.5,32.02 Z",
    id: "AWS-Data-Exchange_Icon_32_Squid",
    fill: "#FFFFFF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchAwsDataExchange32);
export default __webpack_public_path__ + "static/media/Arch_AWS-Data-Exchange_32.77b72f1f13ecf6430b2496c1b3b18741.svg";
export { ForwardRef as ReactComponent };